// @ts-nocheck
import { ApiParameter, del, get, HasPagingParameters, patch, post } from "@insite/client-framework/Services/ApiService";
import {
    ImportStoreListUploadItems,
    StoreListCollectionModel,
    StoreListCustomerCollectionModel,
    StoreListCustomerModel,
    StoreListCustomersCollectionModel,
    StoreListModel,
} from "@store/Framework/Types/ApiModels";

export interface GetStoreListsApiParameter extends ApiParameter, HasPagingParameters {
    storeListWishListFilter?: boolean;
    currentWishListId?: string;
    name?: string;
    getTemporary?: boolean;
}

export interface DeleteStoreListApiParameter extends ApiParameter {
    storeListId: string;
}

export interface AddStoreListApiParameter extends ApiParameter {
    name?: string;
    description?: string;
    temporary?: boolean;
}

export interface GetStoreListApiParameter extends ApiParameter {
    storeListId: string;
}

export interface UpdateStoreListApiParameter extends ApiParameter {
    storeList: StoreListModel;
}

export interface AddSelectedShipTosApiParameter extends ApiParameter {
    storeListId: string;
    storeListCustomerList: StoreListCustomerModel[];
}

export interface DeleteCustomerFromStoreListApiParameter extends ApiParameter {
    storeListId: string;
    storeListCustomerId: string;
}

export interface GetStoreListCustomersApiParameter extends ApiParameter, HasPagingParameters {
    storeListId: string;
    exclude?: ("showAll" | "createNew" | "billTo" | "oneTime")[];
}

export interface ImportStoreListApiParameter extends ApiParameter {
    uploadedItems: ImportStoreListUploadItems[];
    storeListName: string;
    storeListDescription: string;
}

const storeListUrl = "/api/v1/storeList";

export async function getStoreLists(parameter: GetStoreListsApiParameter) {
    const storeListCollection = await get<StoreListCollectionModel>(storeListUrl, parameter);

    return storeListCollection;
}

export function deleteStoreListApi(parameter: DeleteStoreListApiParameter) {
    return del(`${storeListUrl}/${parameter.storeListId}`);
}

export function addStoreList(parameter: AddStoreListApiParameter) {
    return post<StoreListModel>(storeListUrl, {
        name: parameter.name,
        description: parameter.description,
        temporary: parameter.temporary,
    } as StoreListModel);
}

export async function getStoreList(parameter: GetStoreListApiParameter) {
    const { storeListId, ...newParameter } = parameter;
    const storeList = await get<StoreListModel>(`${storeListUrl}/${storeListId}`, newParameter);
    return storeList;
}

export async function getStoreListCustomers(parameter: GetStoreListCustomersApiParameter) {
    const { storeListId, ...newParameter } = parameter;
    const storeListCustomers = await get<StoreListCustomersCollectionModel>(
        `${storeListUrl}/${storeListId}/storeListCustomers`,
        newParameter,
    );
    return storeListCustomers;
}

export async function updateStoreList(parameter: UpdateStoreListApiParameter) {
    const storeListId = parameter.storeList.id;
    const storeListToUpdate = parameter.storeList;
    const storeList = await patch<StoreListModel>(`${storeListUrl}/${storeListId}`, storeListToUpdate);
    return storeList;
}

export async function addSelectedShipTosData(parameter: AddSelectedShipTosApiParameter) {
    const storeListId = parameter.storeListId;
    const storeListCustomerModel = parameter.storeListCustomerList;
    const storeListCustomers = await post<StoreListCustomerCollectionModel>(
        `${storeListUrl}/${storeListId}/storeListCustomers/batch`,
        { storeListCustomerCollection: storeListCustomerModel } as StoreListCustomerCollectionModel,
    );
    return storeListCustomers;
}

export function deleteCustomerFromStoreListApi(parameter: DeleteCustomerFromStoreListApiParameter) {
    return del(`${storeListUrl}/${parameter.storeListId}/storeListCustomers/${parameter.storeListCustomerId}`);
}

export function importStoreList(parameter: ImportStoreListApiParameter) {
    return post<StoreListModel>(`${storeListUrl}/import`, {
        name: parameter.storeListName,
        description: parameter.storeListDescription,
        customerList: parameter.uploadedItems,
    } as StoreListModel);
}

export function validateImportStoreList(parameter: ImportStoreListApiParameter) {
    return post<StoreListModel>(`${storeListUrl}/validate-import`, {
        name: parameter.storeListName,
        description: parameter.storeListDescription,
        customerList: parameter.uploadedItems,
    } as StoreListModel);
}
